/* =====================================================
   Manualskart Live Counter
   Version 1.0
===================================================== */

document.addEventListener("DOMContentLoaded", function () {

    const soldEl = document.getElementById("mk-sold-count");
    const viewEl = document.getElementById("mk-view-count");

    if (!soldEl || !viewEl) return;

    // Get current product handle
    const pathParts = window.location.pathname.split("/");
    const handle = pathParts[pathParts.length - 1];

    // Simple hash function
    function hash(str) {
        let h = 0;

        for (let i = 0; i < str.length; i++) {
            h = ((h << 5) - h) + str.charCodeAt(i);
            h |= 0;
        }

        return Math.abs(h);
    }

    const productHash = hash(handle);

    /* -------------------------
       SOLD COUNT (2–4)
       Always same for product
    --------------------------*/

    function getSoldCount(handle) {

    let total = 0;

    for (let i = 0; i < handle.length; i++) {
        total += handle.charCodeAt(i);
    }

    return (total % 4) + 1;

}

const soldCount = getSoldCount(handle);

soldEl.textContent = soldCount;

/* -------------------------
   VIEWERS (0–5)
--------------------------*/

// Product-specific starting value (0–5)
let currentViewers = productHash % 6;

viewEl.textContent = currentViewers;

function updateViewers() {

    const direction = Math.random() < 0.5 ? -1 : 1;

    let next = currentViewers + direction;

    if (next < 0) next = 1;

    if (next > 5) next = 4;

    if (next === currentViewers) return;

    viewEl.style.opacity = "0";

    setTimeout(function () {

        currentViewers = next;

        viewEl.textContent = currentViewers;

        viewEl.style.opacity = "1";

    }, 200);

}

// Update every 5–8 seconds
setInterval(updateViewers, Math.floor(Math.random() * 3000) + 8000);

});